import React from 'react'

function MailIcon(props) {
  return (
    <svg
      width='48'
      height='30'
      viewBox='0 0 48 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M47.3637 27V3C47.3637 1.89543 46.4683 1 45.3637 1H2.69702C1.59245 1 0.697021 1.89543 0.697021 3V27C0.697021 28.1046 1.59245 29 2.69702 29H45.3637C46.4683 29 47.3637 28.1046 47.3637 27Z'
        fill='#003D87'
        stroke='white'
        strokeWidth='0.5'
      />
      <path
        d='M4.93945 25.606L15.1213 12.0303'
        stroke='white'
        strokeWidth='0.5'
      />
      <path
        d='M43.9697 25.606L33.7879 12.0303'
        stroke='white'
        strokeWidth='0.5'
      />
      <path
        d='M22.9228 22.3748L0.928383 1.86569C0.596397 1.55612 0.815446 1 1.26937 1H46.6985C47.1566 1 47.3735 1.5647 47.0333 1.87139L24.2743 22.3862C23.8891 22.7335 23.3022 22.7285 22.9228 22.3748Z'
        fill='#003D87'
        stroke='white'
        strokeWidth='0.5'
      />
    </svg>
  )
}

export default MailIcon
